// extracted by mini-css-extract-plugin
export default {"revisions":"AuditDetailsHeader_revisions__uki-S","save":"AuditDetailsHeader_save__Zrobu"};